// @flow
'use strict'

const isEmpty_ = require('lodash/isEmpty')

const convertValueToString = require('../../helpers/convertValueToString')
const getFieldValue = require('../../helpers/getFieldValue')
const {
  getFieldReferencedCollection,
  getSchemaDisplayField
} = require('../../schemas/helpers')

/*::
import type { ConnectionProperties, DropdownComponent } from '../../viewer-app-module/platformTypes'
import type { AdapterApiActions, ComponentAdapter, AdapterParameters } from '../types'
import type { Record } from '../../record-store/types'

type UiOption = {
  value: string,
  label: string
}
*/

const adapter /*: AdapterParameters => ComponentAdapter */ = ({
  getFieldType,
  getSchema,
  wixDataProxy
}) => {
  const createOption /*: (Record, string) => UiOption */ = (
    record,
    fieldName
  ) => ({
    value: convertValueToString(getFieldValue(record, fieldName)),
    label: convertValueToString(getFieldValue(record, fieldName)) || ''
  })

  const createOptionForReference /*: (Record, string, string) => UiOption */ = (
    record,
    displayField,
    fieldName
  ) => ({
    value: JSON.stringify({ id: record._id, field: fieldName }),
    label: convertValueToString(record[displayField])
  })

  const getDropdownOptions /*: (string, AdapterApiActions) => Promise<Array<UiOption>> */ = async (
    fieldName,
    actions
  ) => {
    const isReference = getFieldType(fieldName) === 'reference'
    if (isReference) {
      const schema = getSchema()
      const refCollection = getFieldReferencedCollection(fieldName, schema)
      const refSchema = getSchema(refCollection)
      const displayField = getSchemaDisplayField(refSchema)
      if (displayField != null) {
        const { items } = await actions.fetchAll(fieldName)

        return items.map(record =>
          createOptionForReference(record, displayField, fieldName)
        )
      }

      return Promise.resolve([])
    } else {
      const { items } = await actions.fetchAll()

      return items.map(record => createOption(record, fieldName))
    }
  }

  const updateComponent = async (
    { connectionConfig: { properties }, component },
    actions
  ) => {
    // to allow casting component to any
    // prettier-ignore
    const dropdown /*: DropdownComponent */ = (component /*: any */)
    if (properties.value && properties.value.fieldName) {
      const options = await getDropdownOptions(
        properties.value.fieldName,
        actions
      )
      dropdown.options = options
    }
  }

  return {
    isValidContext({ connectionConfig: { properties } }) {
      return !isEmpty_(properties)
    },

    bindToComponent({ component: dropdown }, actions) {},

    currentRecordModified: updateComponent,

    recordSetLoaded: updateComponent,

    currentViewChanged(componentAdapterContext, actions) {},

    currentIndexChanged({ component: dropdown }, actions) {}
  }
}

module.exports = adapter



// WEBPACK FOOTER //
// ./components/adapters/dropdownOptionsAdapter.js